function toggleTheMenu() {
    document.querySelector(".mobile-menu").classList.toggle("mobile-menu--is-visible");
    document.querySelector("body").classList.toggle("freeze");
    return true;
}

window.onload = (event) => {
    document.querySelector(".site-header__menu-icon").addEventListener("click", () => toggleTheMenu());
    document.querySelector(".mobile-menu__close-icon").addEventListener("click", () => toggleTheMenu());

    // Check if it's homepage and body has a class of "home"
    const body = document.querySelector('body');

    // Fetch scrollPosition to see if window is already scrolled
    let scrollPosition = sessionStorage.getItem('scrollPosition');
  
    // Check if the <body> element has the class "home"
    if (body.classList.contains('home')) {
        // Listen for the scroll event on the window
        window.addEventListener('scroll', handleScroll);

        if (window.scrollY > 100 || scrollPosition > 100) {
            const header = document.querySelector('.site-header');
            header.classList.add('sticky'); // Add 'sticky' class
        }

        // if (scrollPosition) {
        //     // Restore scroll position after refresh
        //     window.scrollTo(0, parseInt(scrollPosition, 10));
        // }      
    }
};

// Function to check the scroll position and toggle the 'sticky' class
function handleScroll() {
    // Make the header sticky on homepage
    const header = document.querySelector('.site-header');

    // Check if the user has scrolled more than 100px
    if (window.scrollY > 100) {
        header.classList.add('sticky'); // Add 'sticky' class
    } else {
        header.classList.remove('sticky'); // Remove 'sticky' class
    }

    // Save the current scroll position in sessionStorage
    sessionStorage.setItem('scrollPosition', window.scrollY);
}
